import React from "react";
import PropTypes from "prop-types";
import { portfolioShape } from "shapes";

import PortfolioInfo from "../PortfolioInfo";

import styles from "./NavbarBody.css";

const NavbarBody = (props) => {
  const {
    currentAsset,
    currentAssetLead,
    currentDeal,
    isAssetDetail,
    isAssetLeadDetail,
    isCalendar,
    isDashboard,
    isDealDetail,
    isSettings,
    portfolios,
    selectedPortfolioIDs,
  } = props;

  if (isCalendar || isDashboard || isSettings) return null;
  if (isAssetDetail || isDealDetail || isAssetLeadDetail) {
    const resource = isAssetDetail // eslint-disable-line
      ? currentAsset
      : isAssetLeadDetail
      ? currentAssetLead
      : currentDeal;

    return (
      <div className={styles.wrapper}>
        <div className={styles.sublabel}>
          {resource && resource.portfolio && resource.portfolio.name}
        </div>
        <div className={styles.label}>{resource && resource.name}</div>
      </div>
    );
  }

  return <PortfolioInfo portfolios={portfolios} selectedPortfolioIDs={selectedPortfolioIDs} />;
};

NavbarBody.propTypes = {
  currentAsset: PropTypes.shape({
    name: PropTypes.string.isRequired,
    portfolio: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  currentDeal: PropTypes.shape({
    name: PropTypes.string.isRequired,
    portfolio: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  currentAssetLead: PropTypes.shape({
    name: PropTypes.string.isRequired,
    portfolio: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  selectedPortfolioIDs: PropTypes.arrayOf(PropTypes.number),
  portfolios: PropTypes.arrayOf(PropTypes.shape(portfolioShape)),
  isAssetDetail: PropTypes.bool,
  isAssetLeadDetail: PropTypes.bool,
  isCalendar: PropTypes.bool,
  isDashboard: PropTypes.bool,
  isDealDetail: PropTypes.bool,
  isSettings: PropTypes.bool,
};

export default NavbarBody;
